module.exports = __webpack_public_path__ + "img/1496437640.ce8b9894.jpg";